export const phaseSegments = [
  { name: 'Menstrual', color: '#6391CC', days: [1, 2, 3, 4, 5] },
  { name: 'Follicular', color: '#6CA851', days: [6, 7, 8, 9, 10, 11, 12, 13] },
  { name: 'Ovulatory', color: '#EBD57F', days: [14, 15, 16, 17, 18] },
  { name: 'Luteal', color: '#A9709D', days: [19, 20, 21, 22, 23, 24, 25, 26, 27, 28] },
];
